module.exports = {
	"ha": "fha",
	"id": 5.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 80.31496062992126,
						"dataLabels": {
							"enabled": true,
							"format": "102",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.65354330708661,
						"dataLabels": {
							"enabled": true,
							"format": "91",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 66.92913385826772,
						"dataLabels": {
							"enabled": true,
							"format": "85",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 51.181102362204726,
						"dataLabels": {
							"enabled": true,
							"format": "65",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 40.15748031496063,
						"dataLabels": {
							"enabled": true,
							"format": "51",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.42857142857143,
						"dataLabels": {
							"enabled": true,
							"format": "297",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.31168831168831,
						"dataLabels": {
							"enabled": true,
							"format": "272",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.44155844155844,
						"dataLabels": {
							"enabled": true,
							"format": "257",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": true,
							"format": "231",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 63.63636363636363,
						"dataLabels": {
							"enabled": true,
							"format": "196",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.90189328743546,
						"dataLabels": {
							"enabled": true,
							"format": "563",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.6815834767642,
						"dataLabels": {
							"enabled": true,
							"format": "492",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.06712564543889,
						"dataLabels": {
							"enabled": true,
							"format": "471",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.32185886402753,
						"dataLabels": {
							"enabled": true,
							"format": "426",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.413080895008605,
						"dataLabels": {
							"enabled": true,
							"format": "351",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.47762408462164,
						"dataLabels": {
							"enabled": true,
							"format": "1198",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.28315703824248,
						"dataLabels": {
							"enabled": true,
							"format": "1085",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.02847843775427,
						"dataLabels": {
							"enabled": true,
							"format": "1045",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 81.12286411716842,
						"dataLabels": {
							"enabled": true,
							"format": "997",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.89422294548413,
						"dataLabels": {
							"enabled": true,
							"format": "859",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -19.685039370078737,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.784313725490192,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.593406593406592,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -23.529411764705888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.53846153846154,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.417508417508412,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.514705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.116731517509725,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.151515151515149,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.098106712564541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.611012433392544,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.268292682926833,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.554140127388532,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.6056338028169,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.522375915378361,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.432387312186973,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.686635944700456,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.593301435406694,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.841524573721165,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=127"
			},
			{
				"x": 9,
				"text": "30–39<br>n=308"
			},
			{
				"x": 15,
				"text": "40–49<br>n=581"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=1229"
			}
		],
		"dataTable": {
			"< 30": [
				127,
				102,
				91,
				85,
				65,
				51
			],
			"30–39": [
				308,
				297,
				272,
				257,
				231,
				196
			],
			"40–49": [
				581,
				563,
				492,
				471,
				426,
				351
			],
			"≥ 50": [
				1229,
				1198,
				1085,
				1045,
				997,
				859
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_3.json
// module id = 201
// module chunks = 0